module.exports = __webpack_public_path__ + "img/solution6.ee358797.png";